export class SequentialRequestProcessor {
	queue: Array<() => Promise<any>>;
	job: Promise<void> | null;

	constructor() {
		this.queue = [];
		this.job = null;
	}

	async processCurrent() {
		while (this.queue.length) {
			const queueItem = this.queue.shift();
			if (queueItem) {
				await queueItem();
			}
		}

		this.job = null;
	}

	async enqueue<R>(request: () => Promise<R>) {
		const resultPromise = new Promise((resolve, reject) => {
			const task = async () => {
				try {
					resolve(await request());
				} catch (e) {
					reject(e);
				}
			};

			this.queue.push(task);
		});

		if (!this.job) {
			this.job = this.processCurrent();
		}

		return resultPromise;
	}
}
